import DiscountCodeWrapper from './DiscountCodeWrapper.component';

export default DiscountCodeWrapper;